import { DataTableGroupRowV2Component, dataTableGroupRowV2Template } from './DataTableGroupRowV2';
import styles from './DataTableGroupRowV2.styles.scss';
export const chameleonDataTableGroupRowV2 = DataTableGroupRowV2Component.compose({
    baseName: 'data-table-group-row-v2',
    template: dataTableGroupRowV2Template,
    styles,
});
